import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const prodConfig = {
  apiKey: 'AIzaSyBcH69DejDBlNnVRGz7cuOtlt9y1i8ZciQ',
  authDomain: 'at-and.com',
  databaseURL: 'https://at-and-e1d78.firebaseio.com',
  projectId: 'at-and-e1d78',
  storageBucket: 'at-and-e1d78.appspot.com',
  messagingSenderId: '704781092386'
};
const devConfig = {
  apiKey: 'AIzaSyBg3cACf8xDd0VrW2W8A2Z0DIfIJyO5GAM',
  authDomain: 'at-and.com',
  databaseURL: 'https://at-and-dev.firebaseio.com',
  projectId: 'at-and-dev',
  storageBucket: 'at-and-dev.appspot.com',
  messagingSenderId: '990507064948'
};
const initializeConfig = process.env.NODE_ENV === 'production' ? prodConfig : devConfig;
const firebaseApp = firebase.initializeApp(initializeConfig);

export const firebaseDb = firebase.firestore();
export const firebaseAuth = firebase.auth();
export const firebaseStorage = firebase.storage();

export default {
  app: firebaseApp,
  db: firebaseDb,
  auth: firebaseAuth,
  storage: firebaseStorage,
  firebase
};



// WEBPACK FOOTER //
// ./src/api/firebaseClient.js